// Push pageview event to the DataLayer
export const pageview = (url) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageview',
    page_path: url,
    // Any additional data you want to pass to GTM can be included here
  });
};
